/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

type RichSelectionContextValue = {
  messageSeverity?: 'error';
  selection: 'single' | 'multiple';
  layout: 'xl' | 'md' | 'sm';
};

const RichSelectionContext = createContext<RichSelectionContextValue | null>(null);

const useRichSelectionContext = () => useContext(RichSelectionContext);

export { RichSelectionContext, useRichSelectionContext };
export type { RichSelectionContextValue };
